<!--送货业绩统计-->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn search-picker">
                <div class="search-ctn-right">
                    <div class="search-name">部门</div>
                    <el-cascader
                        ref="orgCascader"
                        class="search-item"
                        v-model="searchData.OrgId"
                        :options="orgSearchData"
                        :props="cascaderProps"
                        size="small"
                        clearable
                        @change="getSIdData"
                        @visible-change="getOrgTree"
                    ></el-cascader>
                    <div class="search-name">操作人</div>
                    <el-select v-model="searchData.SIds" multiple collapse-tags size="small" class="search-item" filterable placeholder="请选择">
                        <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                    <div class="search-name">操作时间</div>
                    <el-date-picker
                        v-model="dateTime"
                        type="daterange"
                        align="right"
                        size="small"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd"
                        @change="handleChange"
                        class="search-name"
                    ></el-date-picker>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="getTableData">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                        <el-button size="small" class="search-btn btn-primary" v-if="permission.export"  @click="exportData">
                        <i class="fa fa-file-excel-o"></i>
                        {{ permission.export }}</el-button>                           
                    </div>
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border=""
                    style="width: 100%"
                    @sort-change="sortChange"
                    :default-sort="{ prop: 'OrderCount', order: 'descending' }"
                    :summary-method="getSummaries"
                    show-summary
                >
                    <el-table-column show-overflow-tooltip width="80px" type="index" sortable label="排名"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="OrgName" label="部门"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="SName" label="操作人"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="110" prop="OrderCount" label="配送单数">
                        <template slot-scope="scope">
                            <el-button @click="showPackingData(scope.row)" type="text" style="padding: 0px" v-if="scope.row.OrderCount > 0">{{ scope.row.OrderCount }}</el-button>
                            <span v-else>{{ scope.row.OrderCount }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="110" prop="OrderTotalAmount" label="配送订单总额"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="110" prop="BoxesCount" label="配送箱数">
                        <template slot-scope="scope">
                            <el-button @click="showBoxesData(scope.row)" type="text" style="padding: 0px" v-if="scope.row.BoxesCount > 0">{{ scope.row.BoxesCount }}</el-button>
                            <span v-else>{{ scope.row.BoxesCount }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-dialog :title="pickDialogTitle" :close-on-click-modal="false" :visible.sync="packingDataVisible" append-to-body width="750px">
            <div v-if="packingDataVisible">
                <deliverOrdersData :SId="sId" :StartDate="searchData.StartDate" :EndDate="searchData.EndDate" @closeDialog="packingDataVisible = false"></deliverOrdersData>
            </div>
        </el-dialog>
        <el-dialog :title="pickDialogTitle" :close-on-click-modal="false" :visible.sync="boxesDeliverVisible" append-to-body width="700px">
            <div v-if="boxesDeliverVisible">
                <deliverBoxesData :SId="sId" :StartDate="searchData.StartDate" :EndDate="searchData.EndDate" @closeDialog="boxesDeliverVisible = false"></deliverBoxesData>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import deliverOrdersData from '@/components/common/deliverOrdersData';
import deliverBoxesData from '@/components/common/deliverBoxesData';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb,
        deliverOrdersData,
        deliverBoxesData
    },
    data() {
        return {
            packingDataVisible: false,
            boxesDeliverVisible: false,
            dateTime: [],
            orgSearchData: [],
            pickDialogTitle: '',
            sId: '',
            searchData: {
                EntpId: this.$util.getLocalStorage('userMsg').EntpId,
                OrgId: '',
                SId: '',
                SIds: [],
                StartDate: '',
                EndDate: ''
            },
            cascaderProps: {
                emitPath: false,
                expandTrigger: 'hover',
                children: 'Childrens',
                label: 'Name',
                value: 'Id',
                checkStrictly: true
            },
            SIdList: [],
            tableSaleData: [],
            tableSaleDataLength: 0,
            tableData: [],
            tableDataLength: 0,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            permission:{},
            SortProp:'',
            SortType:'',             
        };
    },
    created() {
        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);
        this.dateTime.push(date1);
        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1];
        let date2 = new Date(year2, month2, day2, 0);
        this.dateTime.unshift(date2);

        this.searchData.StartDate = date2;
        this.searchData.EndDate = date1;
    },
    mounted() {
        this.permission = this.$util.getPermission('DeliverStat');
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
    },
    methods: {
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    if (index === 4) sums[index] = sums[index].toFixed(2);
                    else sums[index] = sums[index] + '';
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        // 重置表单
        resetSearch() {
            this.$refs.orgCascader.$refs.panel.clearCheckedNodes();
            this.searchData.EntpId = this.searchData.EntpId;
            this.searchData.SId = '';
            this.searchData.SIds = [];
            this.searchData.StartDate = '';
            this.searchData.EndDate = '';
            this.dateTime = [];
            this.searchData.PayStartDate = '';
            this.searchData.PayEndDate = '';
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosPost({
                    url: '/api/DataStatistics/DeliverStatsticst',
                    data: this.searchData
                })
                .then(res => {
                    if (res.errcode != 201) {
                        let data = res.data;
                        this.tableData = data;
                        this.tableDataLength = res.count;
                    }
                })
                .catch(() => {});
        },
        //获取组织树
        getSIdData() {
            if (this.searchData.OrgId) {
                this.$util.getSIdListByOrg(this.searchData.OrgId).then(data => {
                    this.SIdList = data;
                });
            }
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        handleChangeFinishTime(val) {
            if (val) {
                this.searchData.PayStartDate = val[0];
                this.searchData.PayEndDate = val[1];
            } else {
                this.searchData.PayStartDate = '';
                this.searchData.PayEndDate = '';
            }
        },
        getOrgTree(isShow) {
            if (isShow && this.orgSearchData.length == 0) {
                this.$util
                    .axiosGet({
                        url: '/api/EntpInfoManagement/GetOrgTree'
                    })
                    .then(res => {
                        if (res.data) {
                            this.orgSearchData = this.getTreeData(res.data);
                        }
                    });
            }
        },
        // 数列
        getTreeData(data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].Childrens.length < 1) {
                    data[i].Childrens = undefined;
                } else {
                    this.getTreeData(data[i].Childrens);
                }
            }
            return data;
        },
        showPackingData(row) {
            if (row) {
                this.pickDialogTitle = '【' + row.SName + '】配送订单数据';
                this.sId = row.SId;
                this.packingDataVisible = true;
            }
        },
        showBoxesData(row) {
            if (row) {
                this.pickDialogTitle = '【' + row.SName + '】送达箱子数据';
                this.sId = row.SId;
                this.boxesDeliverVisible = true;
            }
        },
        sortChange(event) {
            this.SortProp = event.prop;
            this.SortType = event.order;
        },         
        exportData() {
            let that = this;
            if (that.tableData.length == 0) {
                that.$util.warningMsg('请选择要导出的数据');
                return;
            }
            that.$util.exportFile_post({
                url: '/api/DataStatistics/ExportDeliverStat',
                data:{DeliverStats:that.tableData,SortProp:that.SortProp,SortType:that.SortType},
            });
        },          
    }
};
</script>